export const WORDS = [
  'AGENT',
  'WORLD',
  'ABOUT',
  'HEART',
  'WATER',
  'SIXTY',
  'BOARD',
  'MONTH',
  'MUSIC',
  'PARTY',
  'PIANO',
  'MOUTH',
  'WOMAN',
  'SUGAR',
  'AMBER',
  'DREAM',
  'LAUGH',
  'TIGER',
  'EARTH',
  'MONEY',
  'WORDS',
  'SMILE',
  'LEMON',
  'SOUTH',
  'AFTER',
  'STONE',
  'THING',
  'LIGHT',
  'STORY',
  'POWER',
  'TODAY',
  'RANGE',
  'PEARL',
  'VENOM',
  'PROXY',
  'ROUND',
  'HOVER',
  'CANDY',
  'ABOVE',
  'PHONE',
  'OTHER',
  'SMART',
  'BLACK',
  'MAGIC',
  'FRUIT',
  'RADIO',
  'ROYAL',
  'HONEY',
  'FLAKE',
  'SOUND',
];

export const initialLetterStatuses = {
  'Q': 'incorrect',
  'W': 'incorrect',
  'E': 'incorrect',
  'R': 'incorrect',
  'T': 'incorrect',
  'Y': 'incorrect',
  'U': 'incorrect',
  'I': 'incorrect',
  'O': 'incorrect',
  'P': 'incorrect',
  'A': 'incorrect',
  'S': 'incorrect',
  'D': 'incorrect',
  'F': 'incorrect',
  'G': 'incorrect',
  'H': 'incorrect',
  'J': 'incorrect',
  'K': 'incorrect',
  'L': 'incorrect',
  'Z': 'incorrect',
  'X': 'incorrect',
  'C': 'incorrect',
  'V': 'incorrect',
  'B': 'incorrect',
  'N': 'incorrect',
  'M': 'incorrect',
};
